import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAiDataExtractorPackageDetails, IDataInput } from "../../../../interface/interfaces";


interface IInitialState{
    packageDetailsLoading: boolean,
    packageDetailsData: IAiDataExtractorPackageDetails | null,
    packageDetailsError: string
}

const initialState:IInitialState ={
    packageDetailsLoading: false,
    packageDetailsData: null,
    packageDetailsError: ''
}

const aiDataExtractorPackageDetailsSlice = createSlice({
    name:'packageDetails',
    initialState,
    reducers:{
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchPackageDetailsPadding: (state: IInitialState,  action: PayloadAction<IDataInput>)=>{
            state.packageDetailsLoading = true;
            state.packageDetailsData = null;
            state.packageDetailsError = '';
        },
        fetchPackageDetailsFulfilled: (state: IInitialState, action: PayloadAction<IAiDataExtractorPackageDetails>)=>{
            state.packageDetailsLoading = false;
            state.packageDetailsData = action.payload;
            state.packageDetailsError = '';
        },
        fetchPackageDetailsFailure: (state: IInitialState, action: PayloadAction<string>)=>{
            state.packageDetailsLoading = false;
            state.packageDetailsData = null;
            state.packageDetailsError = action.payload;
        },
        resetPackageDetails: (state: IInitialState)=>{
            state.packageDetailsLoading = false;
            state.packageDetailsData = null;
            state.packageDetailsError = ''
        }
    }
})

export default aiDataExtractorPackageDetailsSlice.reducer;
export const {fetchPackageDetailsFailure, fetchPackageDetailsFulfilled, fetchPackageDetailsPadding, resetPackageDetails} = aiDataExtractorPackageDetailsSlice.actions;